import { ContentNodeUtils, createContentNode, } from '../../ContentNode/ContentNode.utils';
import { DataTypeConfigUtils } from '../../DateTypeConfig/DataTypeConfig.utils';
import { createRuntimeOperationType } from './common';
export const referenceContentNodeOperationType = createRuntimeOperationType({
    kind: 'CONTENT_NODE_REFERENCE',
    dependencies: () => [],
    run: ([queryId, ...selector], context) => {
        if (!queryId)
            return null;
        const queryNode = context.query(queryId);
        if (!queryNode) {
            throw new Error(`Query ${queryId} not found`);
        }
        const queryData = queryNode.queryContentNode;
        if (!selector?.length) {
            return queryData;
        }
        try {
            const queryContentNode = ContentNodeUtils.findContentNode(selector)(queryData);
            return queryContentNode;
        }
        catch (error) {
            console.log(error);
        }
        const queryDefinition = queryNode.queryDataTypeConfig;
        const fieldDefinition = DataTypeConfigUtils.find(selector)(queryDefinition);
        if (!fieldDefinition) {
            throw new Error(`Field definition not found for selector ${selector.join('.')} in query ${queryId}`);
        }
        const contentNode = createContentNode(fieldDefinition, undefined);
        return contentNode;
    },
});
//# sourceMappingURL=content-node-reference.js.map